<template>
  <div class="q-pa-md">
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="filteredRows"
      title="Grupos Já associados ao usuário"
      :columns="columns"
      :loading="disable"
      class="tabela-tamanho-fixo"
      dense
      v-model:pagination="pagination"
      hide-pagination
    >
      <template v-slot:top-right>
        <q-input
          outlined
          rounded
          dense
          debounce="300"
          v-model="filter"
          placeholder="Buscar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template #body-cell-ultima_retirada="props">
        <q-td>
          <span v-if="props.row.ultima_retirada != null">
            {{
              props.row.ultima_retirada
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}
            {{ props.row.ultima_retirada.split(" ")[1] }}</span
          >
        </q-td>
      </template>
      <template #body-cell-prazo_minimo="props">
        <q-td>
          <span v-if="props.row.prazo_minimo != null">
            {{
              props.row.prazo_minimo
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}
            {{ props.row.prazo_minimo.split(" ")[1] }}</span
          >
        </q-td>
      </template>
      <template #body-cell-prazo_maximo="props">
        <q-td>
          <span v-if="props.row.prazo_maximo != null">
            {{
              props.row.prazo_maximo
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}
            {{ props.row.prazo_maximo.split(" ")[1] }}</span
          >
        </q-td>
      </template>
      <template #body-cell-critico="props">
        <q-td>
          <span v-if="props.row.critico == 0">NÃO</span>
          <span v-else>SIM</span>
        </q-td>
      </template>
      <template #body-cell-remover="props">
        <q-td>
          <q-btn
            color="negative"
            round
            icon="delete"
            :disable="props.row.tipo != 'Individual'"
            @click="remover(props.row.group_id)"
            no-caps
          />
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
const columns = [
  {
    name: "grupo_nome",
    label: "Grupo",
    field: "grupo_nome",
    align: "left",
  },
  {
    name: "quantidade_retirada",
    label: "Qtd. Retirada",
    field: "quantidade_retirada",
    align: "left",
  },
  {
    name: "quantidade_total_regra",
    label: "Qtd. Máx (Regra)",
    field: "quantidade_total_regra",
    align: "left",
  },
  {
    name: "tipo",
    label: "Tipo Associação",
    field: "tipo",
    align: "left",
  },
  {
    name: "ultima_retirada",
    label: "Ultima Retirada	",
    field: "ultima_retirada",
    align: "left",
  },
  {
    name: "prazo_minimo",
    label: "Próxima Retirada",
    field: "prazo_minimo",
    align: "left",
  },
  {
    name: "prazo_maximo",
    label: "Prazo Máximo",
    field: "prazo_maximo",
    align: "left",
  },
  {
    name: "critico",
    label: "Crítico?",
    field: "critico",
    align: "left",
  },
  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";

export default {
  props: ["associacao", "atualizar", "id"],
  setup(props) {
    const $q = useQuasar();
    const route = useRoute();
    const store = useStore();
    const rows = ref([]);
    const disable = ref(true);
    let filter = ref("");
    const dados = route.params.id ? JSON.parse(route.params.id) : "";

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 1000,
      rowsNumber: 15,
    });

    const getProdutos = async () => {
      let response = await store.dispatch("user/getGrupoAssosiados", {
        user_id: props.id ? props.id : dados.id,
      });

      if (response.data.result.data.length == 0) {
        $q.notify({
          message: "Esse usuario não possui produtos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      rows.value = response.data.result.data;

      disable.value = false;
    };

    onMounted(getProdutos);

    const remover = async (grupo_id) => {
      try {
        await store.dispatch("user/deletarEpiGrupo", {
          epi_id: dados.id,
          grupo_id: grupo_id,
        });

        $q.notify({
          message: "Produto removido com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getProdutos();
      } catch (error) {
        $q.notify({
          message: "Erro a o remover produto",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      getProdutos(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    const filteredRows = computed(() => {
      if (!filter.value) return rows.value;
      const term = filter.value.toLowerCase();
      return rows.value.filter((row) =>
        row.grupo_nome?.toLowerCase().includes(term)
      );
    });

    watch(
      () => props.atualizar,
      () => {
        setTimeout(() => {
          getProdutos();
        }, 1500);
      }
    );
    watch(
      () => store.state.org.unidadeData,
      () => {
        getProdutos();
      }
    );

    return {
      dados,
      columns,
      rows,
      filteredRows,
      getProdutos,
      pagination,
      handleRequest,
      disable,
      filter,
      remover,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
